import clsx from "clsx";
import styles from "./DropDown.module.scss";
type DropdownOption = {
  [key: string]: string;
};

type DropDownProps = {
  options: DropdownOption[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultOption: string;
  size?: "small";
  [key: string]: unknown;
};

const DropDown: React.FC<DropDownProps> = (props) => {
  const { options, value, onChange, defaultOption, size, ...otherProps } = props;

  return (
    <div className={clsx(styles.selectWrapper, styles[String(size)])}>
      <select className={clsx(styles.select, styles[String(size)])}
        value={value} onChange={onChange} {...otherProps}>
        {defaultOption && <option value="">{defaultOption}</option>}
        {options.map((option, index) => {
          const keys = Object.keys(option);
          const keyValue = keys[0];
          const displayText = keys[1];

          return (
            <option key={index} value={option[keyValue]}>
              {option[displayText]}
            </option>
          );
        })}
      </select>
    </div >
  );
};

export default DropDown;
